export const COLOR_HISTORY_SIZE = 16;
